import './input.css';


interface ToggleProps {
  isToggled: boolean;
  setIsToggled?: (isToggled: boolean, callBackProperty?: string, event?: React.MouseEvent) => void;

  toggledBackgroundColor?: string | 'default';
  untoggledBackgroundColor?: string;
  circleColor?: string;

  isWhiteBackground?: boolean;
  boxShadow?: string;
  callBackProperty?: string;
  isSmall?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({
  isToggled,
  setIsToggled,

  toggledBackgroundColor,
  untoggledBackgroundColor,
  circleColor,

  isWhiteBackground,
  boxShadow,
  callBackProperty,
  isSmall
}) => {


  const getClassName = () => {
    let className = 'toggle-container';

    if (isSmall) {
      className += ' toggle-container-small';
    }

    if (isWhiteBackground) {
      className += ' toggle-container-white';
    }

    if (isToggled && toggledBackgroundColor !== 'default') {
      if (isWhiteBackground) {
        className += ' toggle-container-active-white';
      }
      else {
        className += ' toggle-container-active';
      }
    }
    return className;
  };


  return (
    <div
      className={getClassName()}
      onClick={(event) => setIsToggled ? setIsToggled(!isToggled, callBackProperty, event) : null}
      style={{
        cursor: setIsToggled ? 'pointer' : 'default',
        boxShadow: boxShadow,
        backgroundColor: isToggled ? toggledBackgroundColor : untoggledBackgroundColor,
      }}
    >

      <div
        className={'toggle-circle' + (isWhiteBackground ? ' toggle-circle-white' : '') + (isSmall ? ' toggle-circle-small' : '')}
        style={{
          left: isToggled ? (isSmall ? 10 : 12) : 1,
          backgroundColor: circleColor,
        }}
      />

    </div>
  );
};
